import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const GameManagement = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
        };
    }, []);

    useEffect(() => {
        const individualTabs = document.querySelectorAll("#individualStatusTabs .tab-btn");
        const handleIndividualClick = (e) => {
            individualTabs.forEach(btn => btn.classList.remove("active"));
            e.currentTarget.classList.add("active");
        };
        individualTabs.forEach(tab => {
            tab.addEventListener("click", handleIndividualClick);
        });

        const businessTabs = document.querySelectorAll("#businessStatusTabs .tab-btn");
        const handleBusinessClick = (e) => {
            businessTabs.forEach(btn => btn.classList.remove("active"));
            e.currentTarget.classList.add("active");
        };
        businessTabs.forEach(tab => {
            tab.addEventListener("click", handleBusinessClick);
        });
        return () => {
            individualTabs.forEach(tab => {
                tab.removeEventListener("click", handleIndividualClick);
            });
            businessTabs.forEach(tab => {
                tab.removeEventListener("click", handleBusinessClick);
            });
        };

    }, []);


    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Games Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Games Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#schedule_game" className="d-flex align-items-center btn btn-primary font-18 ms-auto mb-3" style={{ width: 'fit-content' }}>
                        <i className="bx bx-plus ms-1" /> <span>Create</span>
                    </Link>
                    <div className="card">
                        <div className="card-body">
                            <div className="tab-content mt-4">
                                <div className="tab-pane fade show active" id="gamestab" role="tabpanel">
                                    <div className="status-tabs" id="individualStatusTabs">
                                        <button className="tab-btn active" data-tab="all">All</button>
                                        <button className="tab-btn" data-tab="live">Live</button>
                                        <button className="tab-btn" data-tab="scheduled">Scheduled</button>
                                        <button className="tab-btn" data-tab="completed">Completed</button>
                                    </div>
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Game ID</th>
                                                    <th>Teams</th>
                                                    <th>Venue</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Age Group</th>
                                                    <th>Referee</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>GM001</td>
                                                    <td>Team A</td>
                                                    <td>Stadium A</td>
                                                    <td>May-25-2025, 5:00 PM</td>
                                                    <td>U-15</td>
                                                    <td>Michael Anderson</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>GM002</td>
                                                    <td>Team B</td>
                                                    <td>Stadium B</td>
                                                    <td>May-26-2025, 3:00 PM</td>
                                                    <td>U-14</td>
                                                    <td>David Thompson</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>GM003</td>
                                                    <td>Team C</td>
                                                    <td>Stadium C</td>
                                                    <td>May-26-2025, 3:00 PM</td>
                                                    <td>U-16</td>
                                                    <td>James Parker</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/game-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="Reschedule" className="bx bx-calendar-edit" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#delete_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-trash" aria-label="Delete" data-bs-original-title="Delete" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="edit_modal" tabIndex={-1} aria-labelledby="editNotiModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editNotiModalLabel">Reschedule Game</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label">Match ID</label>
                                    <input type="text" className="form-control" placeholder="Enter Match ID" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Venue Location</label>
                                    <input type="text" className="form-control" placeholder="Enter Venue" />
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Date</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Local Time</label>
                                        <input type="time" className="form-control" />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Teams Playing</label>
                                    <div className="row">
                                        <div className="col-md-6 mb-2">
                                            <input type="text" className="form-control" placeholder="Team 1 Name" />
                                            <input type="text" className="form-control mt-2" placeholder="Coach Name" />
                                        </div>
                                        <div className="col-md-6 mb-2">
                                            <input type="text" className="form-control" placeholder="Team 2 Name" />
                                            <input type="text" className="form-control mt-2" placeholder="Coach Name" />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Level</label>
                                    <input type="text" className="form-control" placeholder="Mid" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fees</label>
                                    <input type="number" className="form-control" placeholder="Enter Fee Amount" />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="schedule_game" tabIndex={-1} aria-labelledby="ScheduleGame" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="DownloadModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to create a game?</h5>
                        </div>
                        <div className="modal-footer">
                            <a href="/create-game" className="btn btn-secondary">Schedule Now</a>
                            <a href="/create-game" className="btn btn-primary">Schedule Later</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <label htmlFor="blockMessage" className="form-label">Reason for Delete</label>
                            <textarea className="form-control mb-3" rows={3} placeholder="Enter any specific message..." defaultValue={""} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GameManagement